import styled from 'styled-components';

interface ApprovedCheckProps {
  status?: string;
}

const ApprovedIcon = styled.img`
  margin-left: 8px;
`;

const isApprovedStatus = (status?: string) => {
  return ['COMPLETE', 'APPROVED_EDITABLE', 'APPROVED_FINAL'].includes(status || '');
};

export const ApprovedCheck = ({ status }: ApprovedCheckProps) => {
  if (!isApprovedStatus(status)) {
    return null;
  }

  return (
    <ApprovedIcon 
      src="/images/check-icon.svg" 
      alt="승인됨" 
    />
  );
}; 